const initialState = {
    healthQuestionnaire: JSON.parse(localStorage.getItem('healthQuestionnaire')) || null,
};

const healthQuestionnaireReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HEALTH_QUESTIONNAIRE':
            localStorage.setItem('healthQuestionnaire', JSON.stringify(action.payload));
            return {
                ...state,
                healthQuestionnaire: action.payload,
            };
        default:
            return state;
    }
};

export default healthQuestionnaireReducer;